export default __webpack_public_path__ + "static/media/meal-breakfast-icon.3de3a794.svg";